module.exports = __webpack_public_path__ + "static/img/haiyunbanner.9cc16b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/ship/haiyunbanner.png
// module id = QY3I
// module chunks = 18